/* eslint-disable no-unused-vars */
import React from 'react';
import Modal from './index';
import style from './modal.module.scss';
import UploadArea, { UploadAreaProps } from 'components/uploadArea/uploadArea';

export default function SuccessModal(props: UploadAreaProps) {
  return (
    <Modal open={true} onClose={props.onClose}>
      <div className={style.upload}>
        <UploadArea {...props}></UploadArea>
      </div>
    </Modal>
  );
}
